import { createPageRandom } from "./page_random";

// ハロウィンの飾り。ページの左上の角にあるクモの巣 (body::before) のあたりに、画面の上からクモを下ろす。
// 本文にかからないよう、画面の左の余白に収まる位置にだけ出す
const ROOT_ID = "halloween-decorations";
const HEADING_SELECTOR = ".page-heading, .hero-unit";
// 本文の幅。これより左右の余白が狭い画面では動く飾りを出さない
const CONTENT_WIDTH = 760;
const MIN_GUTTER = 120;

const SPIDER_SVG = `
  <svg viewBox="-10 -8 20 16" aria-hidden="true">
    <g stroke="currentColor" stroke-width="1" fill="none" stroke-linecap="round">
      <path d="M-3 -1 L-8 -5 M-3 0 L-9 -1 M-3 1 L-9 3 M-3 2 L-7 7"/>
      <path d="M3 -1 L8 -5 M3 0 L9 -1 M3 1 L9 3 M3 2 L7 7"/>
    </g>
    <ellipse cx="0" cy="1" rx="3.5" ry="4.5" fill="currentColor"/>
    <circle cx="0" cy="-4" r="2.2" fill="currentColor"/>
  </svg>`;

const pageRandom = createPageRandom();

// クモの巣の横幅の中で、余白からはみ出さない位置に画面の上から糸を垂らす
const addSpider = (root, gutter, heading) => {
  const random = pageRandom();
  const web = parseFloat(getComputedStyle(document.body, "::before").width);
  if (!web) return;
  const x = random(web * 0.15, Math.min(web * 0.45, gutter - 30));
  // LP はヒーローの夜空の中で揺れ、ほかのページは見出しの下の本文の余白まで降りてくる
  const headingBottom = heading.getBoundingClientRect().bottom + window.scrollY;
  const drop = heading.closest(".top-page")
    ? random(160, 400)
    : headingBottom + random(40, 220);

  const spider = document.createElement("div");
  spider.className = "halloween-spider";
  spider.style.left = `${x - 10}px`;
  spider.style.setProperty("--drop", `${Math.round(drop)}px`);
  spider.style.animationDuration = `${random(9, 14).toFixed(1)}s`;
  spider.style.animationDelay = `-${random(0, 8).toFixed(1)}s`;
  spider.innerHTML = `<span class="halloween-spider__swing"><span class="halloween-spider__thread"></span><span class="halloween-spider__body">${SPIDER_SVG}</span></span>`;
  root.appendChild(spider);
};

const render = () => {
  document.getElementById(ROOT_ID)?.remove();

  const heading = document.querySelector(HEADING_SELECTOR);
  if (!heading) return;
  const gutter = (document.documentElement.clientWidth - CONTENT_WIDTH) / 2;
  if (gutter < MIN_GUTTER) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const root = document.createElement("div");
  root.id = ROOT_ID;
  root.setAttribute("aria-hidden", "true");
  addSpider(root, gutter, heading);
  document.body.appendChild(root);
};

document.addEventListener("turbo:load", render);
let resizeTimer;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(render, 300);
});
render();
